// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".booking-table[data-v-86c0e08c]{background-color:#f4f8f9;padding:24px 16px}", ""]);
// Exports
module.exports = exports;
